import React, {useState} from "react";
import {Typography, Link} from "@mui/material";
import {formatTextWithLineBreaks} from "../../config/commonFunctions";

export default function TruncateDescription({description, maxLength}) {
  const [isExpanded, setIsExpanded] = useState(false);

  const regex = /(<([^>]+)>)/gi;

  const handleToggle = () => {
    setIsExpanded((prev) => !prev);
  };

  const truncatedDescription = description.length > maxLength ? `${description.slice(0, maxLength)}...` : description;

  return (
    <Typography variant="body2">
      {isExpanded ? formatTextWithLineBreaks(description) : (truncatedDescription.replace(regex, ""))}
      {description.length > maxLength && (
        <Link
          component="button"
          variant="body2"
          onClick={handleToggle}
          sx={{ml: 1, cursor: "pointer"}}
        >
          {isExpanded ? "Show less" : "Show more"}
        </Link>
      )}
    </Typography>
  );
}
